import React, {Component} from 'react';
import ReactGA from 'react-ga';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import axios from 'axios';
import './app.css';
import Config from './utils/config.js';
import routeAuthenticator from './utils/route-authenticator.js';
import Endpoints from './utils/endpoints.js';
import Header from './app/header.js';
import Home from './app/home.js';
import Stats from './app/stats.js';
import ItemCustomisations from './app/item-customisations.js';
import NewReview from './app/reviews/new/review.js';
import * as actions from './actions/auth.js';

const config = new Config();

function trackPage() {
  const path = 'dashboard-app' + window.location.pathname + window.location.search + window.location.hash;
  if (config.env !== 'test') {
    ReactGA.pageview(path);
  }
}

class App extends Component {

  constructor(props) {
    super(props);
    this.endpoints = new Endpoints(config);
    if (config.env !== 'test') {
      ReactGA.initialize(
        config.gaCode,
        { 
          debug: false,
          gaOptions: {
            cookieDomain: this.endpoints.masterDomain()
          }
        }
      );
      ReactGA.set({ dimension1: 'seller' });
    }
    this.initialUrl = window.location.pathname + window.location.hash;
    this.state = {
      config,
      user: props.user,
      error: props.error,
    };
    this.httpClient = axios.create({
      baseURL: this.endpoints.apiRoot,
      timeout: 30000,
    });
    this.renderApp = this.renderApp.bind(this);
    this.renderAuth = this.renderAuth.bind(this);
  }

  renderApp() {
    const user = this.props.user;
    const endpoints = this.endpoints;
    return (
      <div>
        <Header
          folksyRootEndpoint={this.state.config.appRoot}
          folksyDashboardEndpoint={this.endpoints.oldDashboard()}
          user={this.props.user}
        />
        <Route exact path="/" component={Home}/>
        <Route path="/stats" render={(props) => (
          <Stats
            httpClient={this.httpClient}
            days="30"
            endpoints={this.endpoints}
            {...this.props}
            {...props}
          />
        )}/>
        <Route path="/items/:id(\d+)/customisations" render={({match}) => (
          <ItemCustomisations
            user={user}
            endpoints={endpoints}
            match={match}
          />
        )}/>
        <Route path="/reviews/:orderId([-a-zA-Z0-9_]+)/new" render={({match}) => (
          <NewReview
            user={user}
            endpoints={endpoints}
            match={match}
          />
        )}/>
      </div>
    );
  }

  renderAuth() {
    this.props.signIn(this.endpoints.currentUser());
    return (
      <section className="Auth">Authenticating...</section>
    );
  }

  renderError() {
    // return <section className="AuthError">AUTH ERROR: DELETE ME!</section>;
    window.location = this.endpoints.login();
  }

  render() {
    return (
      <section className="App">
        <Router>
          <div>
            {routeAuthenticator(window.location.pathname, this.props.user) ?
              this.renderApp() :
              (
                this.props.error || this.props.user ?
                  this.renderError() :
                  this.renderAuth()
              )
            }
          </div>
        </Router>
      </section>
    );
  }

}

const mapStateToProps = state => ({
  user: state.auth.user,
  error: state.auth.error,
});

const mapDispatchToProps = dispatch => ({
  signIn: endpoint => dispatch(actions.signIn(endpoint)),
});

export { trackPage };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);



// WEBPACK FOOTER //
// ./src/app.js